// mlsIdCode values that do not have a dedicated MLS API integration. For
// these, we fall back to functionFetchMlsDataFiniti and scope the search to
// the cities the MLS covers so DataFiniti's search is narrowed correctly.
// If a user's profile already has `cities` set, that takes precedence over
// this lookup table (see callers). This could be moved to a Firestore
// collection later if these need to be editable without a deploy, but a
// static lookup is simplest for now.
const MLS_ID_CODE_CITIES_LOOKUP = {
  CO_ALTITUDE:
    "Breckenridge OR Dillon OR Silverthorne OR Frisco OR Blue River OR Steamboat Springs OR Fairplay OR Alma OR Leadville OR Walden",
  CO_ASPENGLENWOOD:
    "Aspen OR Snowmass Village OR Basalt OR Carbondale OR Glenwood Springs OR Marble OR New Castle OR Parachute OR Redstone OR Rifle OR Silt",
  CO_ELEVATE_PIKESPEAK:
    "Colorado Springs OR Monument OR Fountain OR Woodland Park OR Manitou Springs OR Cripple Creek or Canon City OR Pueblo OR Castle Rock",
  CO_GRANDJUNCTION:
    "Grand Junction OR Fruita OR Palisade OR De Beque OR Collbran OR Mesa OR Molina OR Loma OR Mack OR Whitewater OR Gateway",
  CO_GRANDCOUNTY:
    "Dillon OR Empire OR Fraser OR Granby OR Grand Lake OR Hot Sulphur Springs OR Kremmling OR Parshall OR Silverthorne OR Tabernash OR Winter Park",
  CO_PPMLS: // old for Pikes Peak MLS now Elevate
    "Colorado Springs OR Monument OR Fountain OR Woodland Park OR Manitou Springs OR Cripple Creek or Canon City OR Pueblo OR Castle Rock",
  CO_Pueblo: "Pueblo",
  CO_ROYALGORGE:
    "Canon City OR Florence OR Penrose OR Rockvale OR Coal Creek OR Cotopaxi or Westcliffe",
  CO_SPANISHPEAKS:
    "Trinidad OR Walsenburg OR La Veta OR Cuchara OR Stonewall OR Aguilar OR Las Animas OR Huerfano",
  CO_SUMMIT:
    "Breckenridge OR Dillon OR Silverthorne OR Frisco OR Blue River OR Steamboat Springs OR Fairplay OR Alma OR Leadville OR Walden",
  CO_TELLURIDE:
    "Telluride OR Mountain Village OR Ophir OR Sawpit OR Placerville OR Norwood OR Rico",
  CO_VMLS:
    "Vail OR Avon OR Eagle OR Beaver Creek OR Edwards OR Minturn OR Red Cliff OR Gypsum OR Dotsero",
};

// Narrow a DataFiniti MLS search to the cities the MLS covers: prefer the
// user's own profile cities, otherwise fall back to the mlsIdCode -> cities
// lookup table above.
export function getCitiesForMlsSearch(currentUserProfile, mlsIdCodeSelected) {
  let citiesForSearch = currentUserProfile?.cities;
  if (!citiesForSearch || mlsIdCodeSelected) {
    citiesForSearch = MLS_ID_CODE_CITIES_LOOKUP[mlsIdCodeSelected];
  }
  return citiesForSearch;
}

export default MLS_ID_CODE_CITIES_LOOKUP;
